module.exports = __webpack_public_path__ + "static/media/pdf.e4ac0ca5.png";